module.exports = __webpack_public_path__ + "static/media/C_S02.434b9214.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/C_S02.png
// module id = 13
// module chunks = 0